import { Object3D, PointLight, DirectionalLight } from 'three'

export function isDirectionalLight(
  object: Object3D | PointLight | DirectionalLight,
): object is DirectionalLight {
  return (object as DirectionalLight).isDirectionalLight
}

export function isPointLight(
  object: Object3D | PointLight | DirectionalLight,
): object is PointLight {
  return (object as PointLight).distance !== undefined
}
